var debounce = function debounce(fn, delay) {
  var option = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    leading: true,
    trailing: true
  };
  var timeout;
  var isLeadingInvoked = false;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (timeout) {
      clearTimeout(timeout);
    }
    if (option.leading && !timeout) {
      fn.apply(void 0, args);
      isLeadingInvoked = true;
    } else {
      isLeadingInvoked = false;
    }
    timeout = setTimeout(function () {
      if (option.trailing && !isLeadingInvoked) {
        fn.apply(void 0, args);
      }
      timeout = null;
    }, delay);
  };
};
var debounce$1 = debounce;

export { debounce$1 as default };
//# sourceMappingURL=debounce.js.map
